import { API, graphqlOperation } from "aws-amplify";

import { listJobOpportunitiesQuery } from "./graphql/queries";

const listJobOpportunities = () =>
  API.graphql(graphqlOperation(listJobOpportunitiesQuery));

export default listJobOpportunities;
